import { useEffect, useRef, useState } from "react";
import { useCalculator } from "../assets/js/ContextProviders/CalculatorContext";
import { useOnScreen } from "../assets/js/ContextProviders/OnScreenContext";

function ReviewStarBar(props) {

    const { isOnScreen, DivScreenRef, checkIfOnScreen } = useOnScreen();

    const { Percentage, Add } = useCalculator();

    // Count the occurrences of the target number in the array
    function countNo(array, no) {
        // Add a return statement here
        return array.reduce((count, number) => {
            return number === no ? count + 1 : count;
        }, 0);
    }


    const [Star, setStar] = useState(0)
    const [totalstars, settotalstars] = useState(0)
    useEffect(() => {
        if (isOnScreen) {
            if (props.Reviews) {
                setStar(countNo(props.Reviews, parseInt(props.star)))
                settotalstars((props.Reviews).length)
                const starpercent = Percentage(Star, totalstars)
                const starElement = document.getElementById(`Review-${props.star}star`);
                if (starElement) {
                    starElement.style.width = `${starpercent}%`;
                }
            }
        } else {
            if (props.Reviews) {
                const starElement = document.getElementById(`Review-${props.star}star`);
                if (starElement) {
                    starElement.style.width = `0%`;
                }
            }
        }
    }, [props.Reviews, isOnScreen, totalstars, Star])

    return (
        <div className="ReviewBars" ref={DivScreenRef}>
            <div className="ReviwBar-barandno">
                <div className="ReviewBar-no">
                    {props.star}
                </div>
                <div className="ReviewBar-bar">
                    <div className="ReviewBar-bar-filled" id={`Review-${props.star}star`}></div>
                </div>
            </div>
        </div>
    );
}

export default ReviewStarBar;